import { autoinject } from 'aurelia-framework';
import { PLATFORM } from 'aurelia-pal';
import { activationStrategy, RouterConfiguration, Router } from 'aurelia-router';

@autoinject
export class ReportingApp {
	constructor(private router: Router) { }
	
	configureRouter(config: RouterConfiguration, router: Router) {
		config.options.pushState = true;
		// collection addition in route is because of the MVC based List, Print and such routes. 
		// Don't use root configuration because of a bug in template routing that causes href attributes generated without the base url part (https://github.com/aurelia/router/issues/306, https://github.com/aurelia/templating-router/issues/46)
		// config.options.root = '/reports/collection';

		config.map([
			{
				route: '/reports/collection/list',
				name: 'report-list',
				moduleId: PLATFORM.moduleName('./report-list'),
				activationStrategy: activationStrategy.invokeLifecycle,
				settings: {
					links: [{
						title: 'Reports_Report_Link_NewReport',
						route: { name: 'new-report' }
					}, {
						title: 'Reports_Report_Link_ImportWordTemplate',
						route: { name: 'word-template'}
						}]
				}
			},
			{
				route: '/reports/collection/:reportId/for-customer/:customerId',
				name: 'report-entry',
				moduleId: PLATFORM.moduleName('./report-view'),
				activationStrategy: activationStrategy.invokeLifecycle,
				settings: {
					links: [{
						title: 'Reports_Link_Edit',
						route:  { name: 'edit-report', params: ['reportId', 'customerId'] }
					}, {
						title: 'Reports_Link_ExportToWord',
						route: { url: '/reports/{reportId}/for-customer/{customerId}/export/word', params: ['reportId', 'customerId'] },
						isWordExportButton: true
					}, {
						title: 'Reports_Link_ExportToExcel',
						route: { url: '/reports/{reportId}/for-customer/{customerId}/export/excel', params: ['reportId', 'customerId'] }
					}, {
						title: 'Reports_Link_Print',
						route: { url: '/reports/{reportId}/for-customer/{customerId}/print', params: ['reportId', 'customerId'] }
					}, {
						title: 'Reports_Button_BackToList',
						route:  { url: '/reports/collection/list?restoreState=1' },
						isBackButton: true
					}]
				}
			},
			{
				route: '/reports/collection/word-template',
				name: 'word-template',
				moduleId: PLATFORM.moduleName('./report-word-template'),
				activationStrategy: activationStrategy.invokeLifecycle,
				settings: {
					links: [{
						title: 'Reports_Link_ToReportingFrontPage',
						route: { name: 'report-list' },
						isBackButton: true
					}]
				}
			},
			{
				route: '/reports/collection/new',
				name: 'new-report',
				moduleId: PLATFORM.moduleName('./new-report-container'),
				activationStrategy: activationStrategy.invokeLifecycle
			},
			{
				route: '/reports/collection/new/for-customer/:customerId/preview',
				name: 'preview-report',
				moduleId: PLATFORM.moduleName('./report-edit'),
				activationStrategy: activationStrategy.invokeLifecycle,
				settings: {
					backButtonResource: 'Reports_Edit_Button_BackToNewReport'
				}
			},
			{
				route: '/reports/collection/:reportId/for-customer/:customerId/edit',
				name: 'edit-report',
				moduleId: PLATFORM.moduleName('./report-edit'),
				activationStrategy: activationStrategy.invokeLifecycle,
				settings: {
					backButtonResource: 'Reports_Edit_Button_BackToReport'
				}
			},
			{
				route: '/reports/collection/:reportId/for-customer/:customerId/delete',
				name: 'delete-report',
				moduleId: PLATFORM.moduleName('./report-delete'),
				activationStrategy: activationStrategy.invokeLifecycle,
				settings: {
					backButtonResource: 'Button_Cancel'
				}
			},
			{
				route: '/reports/collection/',
				redirect: '/reports/collection/list'
			}
		]);
	}
}
